import { Feature } from '@tencent/workbench';
import { config } from './config';
import { BaseImageFeature } from '@src/framework/workbench/common/feature/base-image-feature';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

@Feature()
export class TailorPicFeature extends BaseImageFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public shouldHide(configId?: string): boolean {
        const type = this.getSelectModel()?.type;
        const isMultiOrGroupModel = !!(type && [UIModelType.MULTIPLY, UIModelType.GROUP].includes(type));
        return this.shouldTalorHide() || (configId === config.id ? isMultiOrGroupModel : !isMultiOrGroupModel);
    }

    public shouldMenuHide(): boolean {
        return this.shouldTalorHide();
    }
}
